import { AppHelper } from "../appHelper"
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp";
import { Button } from "../core/components/button";
import { IsPanelbarDetails } from "../core/components/isPanelbarDetails";
import { Grid } from "../core/components/grid";
import { IsSearchField } from "../core/components/isSearchField";
import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { SheetEventType } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import React from "react";

export interface EntityWeeklyReportList extends Entity {
    Von: string;
    Bis: string;
    RessNr: string;
    BelegNr: number;
    Ursprung: string;
    useThinfinityDgfUrl: boolean;
}

export interface WeeklyReportListAppProps extends AppBaseProps {
    weeklyReportList: any;
    entity: EntityWeeklyReportList;
}

export class WeeklyReportListApp extends React.Component<WeeklyReportListAppProps, any> {
    weeklyReportListGridOptions = {};
    translations = {};
    ressNr: string = null;
    dateVon: Date;
    dateBis: Date;
    weeklyReportList: any = {};
    private deleteButtonActive = false;
    private reportAvailable = false;

    common = new AppHelper();

    private months = {
        0: "Standard.Month.January",
        1: "Standard.Month.February",
        2: "Standard.Month.March",
        3: "Standard.Month.April",
        4: "Standard.Month.May",
        5: "Standard.Month.June",
        6: "Standard.Month.July",
        7: "Standard.Month.August",
        8: "Standard.Month.September",
        9: "Standard.Month.October",
        10: "Standard.Month.November",
        11: "Standard.Month.December"
    }

    constructor(props: WeeklyReportListAppProps) {
        super(props)
        this.common.init(this);

        this.dateVon = kendo.parseDate(props.entity.Von);
        this.dateBis = kendo.parseDate(props.entity.Bis);
        this.ressNr = Helper.hasValue(props.entity.BelegNr) ? null : props.entity.RessNr;
        this.weeklyReportList = props.weeklyReportList;

        this.initApp();
    }

    private initApp = () => {
        $(document).bind("keyup", this.onKeyUp);
    }

    componentWillUnmount() {
        $(document).unbind("keyup", this.onKeyUp);
    }

    private onKeyUp = (e: JQuery.KeyUpEvent) => {
        const arrowLeft = 37;
        const arrowRight = 39;
        const keyCode = e.keyCode;
        switch (keyCode) {
            case arrowLeft:
                this.handleClickLeft()
                break;
            case arrowRight:
                this.handleClickRight()
                break;
        }
    }

    componentDidMount() {
        if (Helper.hasValue(this.props.entity.BelegNr)) {
            HTTPService.get("WeeklyReport/GetInitParamsForReport?id=" + this.props.entity.BelegNr)
                .then((params) => {
                    this.dateVon = kendo.parseDate(params.Von);
                    this.dateBis = kendo.parseDate(params.Bis);
                    this.ressNr = params.RessNr;
                    this.reloadData().then(() => {
                        this.openWeeklyReport(this.props.entity.BelegNr, this.props.entity.Ursprung);
                    })
                });
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    openWeeklyReport = async (belegNr, ursprung) => {
        if (this.props.entity.useThinfinityDgfUrl) {
            const dummyLink = $("<a>").text("thinfinity").attr({ id: "dummyLink", href: Config.baseUrl + "ServiceReport/ThinfinityDgfOpen?belegNr=" + belegNr, target: "_blank" }).css({ display: "none" });
            $("body").append(dummyLink);
            $("#dummyLink")[0].click();
            $(dummyLink).remove();
        }
        else {
            if (!Helper.hasValue(ursprung)) {
                if (!(await DialogHelper.confirm(this.translations["WebSMS.WeeklyReport.AndererUrsprungAlsWebSMS"]))) {
                    return;
                }
            }

            this.showViewWeeklyReport("WeeklyReport/Edit?id=" + encodeURIComponent(belegNr));

        }
    }

    createNewWeeklyReport = (ressNr, von, bis) => {
        if (this.props.entity.useThinfinityDgfUrl) {
            DialogHelper.alert(this.translations["WebSMS.WeeklyReport.CreatingThinfinityNotSupported"]);
        }
        else {
            this.showViewWeeklyReport(
                "WeeklyReport/New?ressNr=" + encodeURIComponent(ressNr)
                + "&von=" + Helper.dates.getISODateString(von)
                + "&bis=" + Helper.dates.getISODateString(bis)
            );
        }
    }

    showViewWeeklyReport = (url) => {
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, null, true);
        sheet.setTitle(this.translations["WebSMS.WeeklyReport.WeeklyReport"]);
        sheet.bind(SheetEventType.SavedSuccessfully, (data) => {
            this.reloadData();
        });
        sheet.bind(SheetEventType.ItemDeleted, (data) => {
            this.reloadData();
        });
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.RELOAD) {
            this.reloadData();
        }
        else if (type === ToolBarStandardButtonType.EDIT) {
            if (dataItem.Vorhanden) {
                this.openWeeklyReport(dataItem.Belegnr, dataItem.Ursprung);
            }
            else {
                this.createNewWeeklyReport(this.ressNr, kendo.parseDate(dataItem.Von), kendo.parseDate(dataItem.Bis));
            }
        }
        else if (type === ToolBarStandardButtonType.DELETE) {
            this.deleteWeeklyReport(dataItem.Belegnr);
        }
    }

    reloadData = () => {
        return new Promise<void>(resolve => {
            HTTPService.get<JsonResultClass>("WeeklyReport/InitListView/?ressNr=" + encodeURIComponent(this.ressNr == null ? "" : this.ressNr)
                + "&von=" + Helper.dates.getISODateString(this.dateVon)
                + "&bis=" + Helper.dates.getISODateString(this.dateBis)
            )
                .then(result => {
                    this.weeklyReportList = result.Data;
                    this.setState({}, () => {
                        resolve();
                    });
                });
        });
    }

    deleteWeeklyReport = async (belegNr: number) => {
        let isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            let result = await HTTPService.post<JsonResultClass>("WeeklyReport/Delete/?belegNr=" + encodeURIComponent(belegNr));
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(this.translations["Ressource.LöschenErfolgreich"]);
                this.reloadData();
            }
            else
                NotificationHelper.showErrorMessage(result.Message);
        };
    }

    handleClickLeft = () => {
        this.dateVon.setMonth(this.dateVon.getMonth() - 1, 1);
        this.dateBis = new Date(this.dateVon.getTime());
        this.dateBis.setMonth(this.dateVon.getMonth() + 1, 0);
        this.reloadData();
    }

    handleClickRight = () => {
        this.dateVon.setMonth(this.dateVon.getMonth() + 1, 1);
        this.dateBis = new Date(this.dateVon.getTime());
        this.dateBis.setMonth(this.dateVon.getMonth() + 1, 0);
        this.reloadData();
    }

    private onSelectionChange = (dataItem) => {
        this.deleteButtonActive = Helper.hasValue(dataItem) && Helper.hasValue(dataItem.id);
        this.reportAvailable = Helper.hasValue(dataItem) && Helper.hasValue(dataItem.id);
        this.setState({});
    }

    createGrid = () => {
        let issfProps = ComponentHelper.createFactory().getDefaultSearchFieldProps();
        issfProps.value = this.ressNr;
        issfProps.disabled = !this.weeklyReportList.RecordRight.ZentralerUser; // Nur zentrale User dürfen die Ressource wechseln
        issfProps.field.readOnlyTextField = true;
        issfProps.field.searchWindowTitle = this.translations["Ressource.Ressourcensuche"];
        issfProps.field.searchWindowUrl = "DynamicSearch/Window/Resource";
        issfProps.onChange = (_, value) => {
            this.ressNr = value;
            this.reloadData();
        };

        let ispdProps = ComponentHelper.createFactory().getDefaultPanelbarDetailsProps();
        ispdProps.field.url = "ResourceLookup/ResourceHeader";
        ispdProps.field.template = "ResourceDetails";
        ispdProps.handleEval = this.common.evalAction;
        ispdProps.value = this.ressNr;

        let editCaption = this.weeklyReportList.RecordRight.CanWrite ? Config.translations.editLabel : Helper.getTranslation("Standard.Öffnen");
        
        let standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.RELOAD, caption: this.translations["MonitorBaum.NeuLaden"], enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: editCaption, enabled: this.weeklyReportList.RecordRight.CanWrite || this.reportAvailable });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.weeklyReportList.RecordRight.CanDelete && this.deleteButtonActive });
        return (
            <div style={{ padding: "0 15px" }}>
                <div className="flex-container">
                    <div className="flex-container flex-container--row flex-container--align-center" style={{ height: "auto", marginTop: 10, marginBottom: 10 }}>
                        <label style={{ marginRight: 20 }}>{this.translations["Field.Ressource.ressnr"]}</label>
                        <div style={{ width: 200 }}>
                            <IsSearchField {...issfProps} />
                        </div>
                        <Button handleClick={this.handleClickLeft} buttonStyle={{ marginLeft: 20 }} iconName={"arrow-alt-left"} />
                        <Button handleClick={this.handleClickRight} buttonStyle={{ marginLeft: 5 }} iconName={"arrow-alt-right"} />
                        <label style={{ marginLeft: "20px", fontSize: "17px" }}>{this.translations[this.months[this.dateVon.getMonth()]] + ", " + this.dateVon.getFullYear()}</label>
                    </div>
                    <div style={{ width: 360 }}>
                        <IsPanelbarDetails {...ispdProps} />
                    </div>
                    <div className="flex-container__item" style={{ marginTop: 5 }}>
                        <Grid
                            id="weeklyReportList"
                            data={this.weeklyReportList.WeeklyEntries}
                            options={this.weeklyReportListGridOptions}
                            standardButtons={standardButtons}
                            onClickStandardButton={this.handleClickStandardButton}
                            onSelectionChanged={this.onSelectionChange}
                        >
                        </Grid>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};
